
import { Grid, GridItem, NoticeBar, Swipe, SwipeItem } from 'vant';
import { errorModal } from '../assets/js/xjcommon';
import {jsSdk} from '../assets/libs/loadjs'
import { watch } from 'less';

// Lazyload 是Vue指令,使用前需要对指令进行注册
export default {
  name: 'home',
  components: {
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [NoticeBar.name]: NoticeBar,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem
  },
  data () {
    return {
      // 公众号的名称
      customerName: '',
      // 当前设备号
      nowImei: '',
      // 公众号介绍
      // 是否显示公众号名称
      showCustomer: false,
      // customerIntroduce: ['随时随地查看爱车位置', '实时监控爱车安全'],
      customerIntroduce: ['', ''],
      // 首页顶部的文字位置,值为left或right
      topTextPosition: 'right',
      // 首页顶部的文字颜色,值为white,theme,black
      topTextColor: 'white',
      // 当前设备的屏幕宽度
      bannerHeight: 210,
      // 广告图片列表
      adList: [{img_url:require('../assets/images/img_header.png'), title: '欢迎您'}],
      // 广告图片最多显示张数
      adMaxNum: 8,
      // 通知内容
      noticeText: '',
      // 行程报告url
      historyMarchUrl: '',
      // 菜单列表
      menuList: [],
      // 所有菜单信息(这里没用,放在 menuInfo.js中备用)
      menuListAll: [],
      // 彩蛋点击数量
      eggClickNum: 0,
      token:this.$store.state.token
    }
  },
  methods: {
      // 监听error 函数
      handleErrorFn (e) {
        // 跳转失败
        console.log(JSON.stringify(e), '跳转失败')
      },
      // 监听launch 函数
      handleLaunchFn (e) {
        // 跳转成功
        console.log(JSON.stringify(e), '跳转成功')
      },
    onClickNotice () {
      if( (++ this.eggClickNum) >= 5 ){
        if( !window.__vconsole ){
          window.__vconsole = new window.VConsole();
        }
        // jsSdk(this.$store.state.customer, ['scanQRCode']).then(function(){
        //   wx.scanQRCode({
        //     needResult : 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        //     scanType : ["qrCode","barCode"], // 可以指定扫二维码还是一维码，默认二者都有
        //     success : function(res)
        //     {
        //       if(res.resultStr){
        //         var result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
        //         console.log(`result: ${result}`);
        //         if (result.indexOf(',') !== -1) {
        //           var arr = result.split(',');
        //           if (arr[1].length==19 || arr[1].length==20 || arr[1].length==11) {
        //             account.value = arr[1];
        //           } else {
        //             console.log('请重新扫码1')
        //           }
        //         }else{
        //           if(result.length==19 || result.length==20 || result.length==11){
        //             account.value = result;
        //           }else{
        //             console.log('请重新扫码2')
        //           }
        //         }
        //       }else {
        //         console.log('请重新扫码3')
        //       }
        //     }
        //   });
        // });
      }
    },
    // 获取设备设置(如摄像头类型)
    getSetFn () {
      let _this = this;
      this.$axios.post('/v3/u/setting/ability', {})
        .then(function (response) {
          // console.log(response);
          _this.$toast.clear();
          if (response.data.ret === 0) {
            _this.$store.state.devSet = true;
            _this.setDataProcessing(response.data.data);
          } else {
            _this.$dialog({
              message: response.data.msg ? response.data.msg + '（' + response.data.ret + '）' : '获取设置失败（' + response.data.ret + '）'
            })
          }
        })
        .catch(function (error) {
          _this.$toast.clear();
          console.log(error);
          errorModal(error, 101);
        })
    },
    // 对获取到的设置进行处理
    setDataProcessing (resData) {
      // 设备摄像头
      let devCameraList = [
        { name: '前置摄像头', value: 1 , isShow:resData.front},
        { name: '后置摄像头', value: 2 , isShow:resData.rear},
        // { name: '前+后摄像头', value: 3 }
        { name: '全景摄像头', value: 4 , isShow:resData.full}
      ];
      // if (resData.front === 1 && resData.rear === 0) {
      //   devCameraList = [{ name: '前置摄像头', value: 1 }]
      // } else if (resData.front === 0 && resData.rear === 1) {
      //   devCameraList = [{ name: '后置摄像头', value: 2 }]
      // } else if (resData.front === 0 && resData.rear === 0) {
      //   devCameraList = []
      // }
      this.$store.state.devCameraList = devCameraList.filter(item=>item.isShow);
      // 导航相关(保存到cookies而不是store是因为后者在页面刷新时只能获得到初始值)
      this.$cookies.set('navAbility', this.parseNavigate(resData.navigate));
    },
    // 预约导航2^0,好友指路2^1,接人服务2^2
    parseNavigate (num) {
      let navigate = num % 2 === 1;
      num = parseInt(num / 2);
      let friendDirect = num % 2 === 1;
      num = parseInt(num / 2);
      let pickUp = num % 2 === 1;
      return {navigate, friendDirect, pickUp};
    },
    // 获取设备基本信息(如位置信息,sim卡状态)
    getInfoFn () {
      let _this = this;
      this.$toast.loading({
        overlay: true,
        duration: 0,
        message: '加载中...'
      });
      this.$axios.post('/v3/u/vehicle/baseInfo', {})
        .then(function (response) {
          _this.$toast.clear();
          if (response.data.ret === 0) {
            // 保存信息
            _this.versionType = response.data.data.versionType;
            _this.$store.state.nowIccid = response.data.data.iccid || '';
            // 如果不保存到cookies在非首页刷新会重置为空
            _this.$cookies.set('nowIccid', response.data.data.iccid || '');
            localStorage.setItem('cameraTemplate', response.data.data.cameraTemplate);
            _this.getSetFn();
          } else {
            _this.$dialog({
              message: response.data.msg ? response.data.msg + '（' + response.data.ret + '）' : '获取设备信息失败（' + response.data.ret + '）'
            })
          }
        })
        .catch(function (error) {
          _this.$toast.clear();
          errorModal(error, 103);
        })
    },
    // 获取广告banner
    getIndexBannerFn () {
      let _this = this;
      this.$axios.post('/v3/u/ad/getAdDetail', { customer:this.$store.state.customer, name: 'wxIndexBanner' })
        .then(function (response) {
          // console.log(response);
          // _this.$toast.clear();
          if (response.data.ret === 0) {
            if (response.data.data && response.data.data.length > 0) {
              let adList = [];
              for(let i = 0; i < response.data.data.length; i++){
                if (i < _this.adMaxNum) {
                  adList.push({
                    img_url: response.data.data[i].img_url,
                    title: response.data.data[i].title,
                    url: response.data.data[i].url,
                    scheme: response.data.data[i].scheme
                  })
                }
              }
              _this.adList = adList;
              _this.$store.state.indexBanner = adList;
            }
          } else {
            _this.$dialog({
              message: response.data.msg ? response.data.msg + '（' + response.data.ret + '）' : '获取图片失败（' + response.data.ret + '）'
            })
          }
        })
        .catch(function (error) {
          // _this.$toast.clear();
          errorModal(error, 104);
        })
    },
    // 跳转到广告连接
    toAdLinkFn (to, link) {
      if (to) {
        this.$router.push('/' + to);
      } else if (link) {
        // 临时设置
        if(this.customer === 'HuLianHT'){
          if(this.versionType ==='V98P'){
            window.location.href = link;
          }
        }else{
          window.location.href = link;
        }
      }
    },
    // 获取菜单列表
    getIndexMenuFn () {
      this.$toast.loading({
        overlay: true,
        duration: 0,
        message: '加载中...'
      });
      this.$axios.post('/v3/u/appMenu/getMenu', { customer:this.$store.state.customer })
        .then((response) =>{
          this.$toast.clear();
          if (response.data.ret === 0) {
            if (response.data.data && response.data.data.length > 0) {
              let menuList = response.data.data.map(item=>{
                let imgUrl = ""
                try {
                  imgUrl = item.img_url ?item.img_url: require('../assets/images/home/' + item.icon_name + '.png');
                } catch (error) {
                  imgUrl=require('../assets/images/home/ic_position_server.png')
                }
                return {
                id: item._id,
                text: item.title,
                // 自定义图标不存在就用 默认图标
                imgUrl,
                to: item.to ? item.to : '',
                url: item.to ? '' : item.url,
              }});
              this.menuList = menuList;
              this.$store.state.menuList = menuList;
            }
          } else {
            this.$dialog({
              message: response.data.msg ? response.data.msg + '（' + response.data.ret + '）' : '获取菜单失败（' + response.data.ret + '）'
            })
          }
        })
        .catch((error) =>{
          this.$toast.clear();
          errorModal(error, 105);
        })
    },
    menuHandle(item){
      if(item.to === "logout"){
        this.logoutHandle()
      }else{
        if(["tuyunDownload","airclean"].includes(item.to)){
          this.$router.push(item.to)
        }else if($cookies.get('imei')){
          this.$router.push(item.to)
        }else{
          this.$dialog({
            message: "请先绑定设备"
          })
        }
      }
    },
    logoutHandle(){
      this.$dialog.confirm({
        title: '',
        message: '你确定要解除微信与手机号之间的绑定关系吗？'
      }).then(() => {
        this.$axios.post('/v3/w/o/unBindWxUser', { customer:this.$store.state.customer })
        .then(response=>{
          this.$cookies.keys().forEach(cookie => this.$cookies.remove(cookie))
          WeixinJSBridge.call('closeWindow');
        })
      }).catch(() => {
        // on cancel
      });

    },
    setCarInfoByImei () {
      this.$axios.post('/v3/u/user/getAllVehicle',{}).then((response) =>{
        if (response.data.ret === 0) {
          let reqData = response.data.data;
          if(reqData.length){
            const findOtherDevice = (reqData||[]).shift();
            this.setDefaultImei(findOtherDevice.imei)
          }else{
            this.$cookies.set('imei', "");
          }
        }else{
          this.$dialog({
            message: response.data.msg ? response.data.msg + '（' + response.data.ret + '）' : '获取设备列表失败（' + response.data.ret + '）'
          })
        }
      })
  },
  setDefaultImei(imei){
    this.$axios.post('/v3/u/user/setFavoriteVehicle',{imei:imei}).then(res=>{
      if (res.data.ret === 0) {
          this.$cookies.set('imei', imei);
          this.getInfoFn();
        }else{
          this.$dialog({
            message: res.data.msg ? res.data.msg + '（' + res.data.ret + '）' : '设置缺省设备失败（' + res.data.ret + '）'
          })
        }
    })
  },
  },
  created () {
    // banner图加载(只加载一次)
    this.bannerHeight = (document.documentElement.clientWidth || window.screen.width) > 768 ? 768 / 2 : parseInt((document.documentElement.clientWidth || window.screen.width) / 2);
    if (this.$store.state.indexBanner && this.$store.state.indexBanner.length > 0) {
      this.adList = this.$store.state.indexBanner;
    } else {
      this.getIndexBannerFn();
    }
    // 菜单加载
    if (this.$store.state.menuList && this.$store.state.menuList.length > 0) {
      this.menuList = this.$store.state.menuList;
    } else {
      this.getIndexMenuFn();
    }
    // 是否重新获取设备设置
    if (this.$store.state.isChangeDev) {
      this.$store.state.isChangeDev = false;
      this.getSetFn();
    }

    // xj edit 20191015 移动到App.js
    // if (this.$store.state.isDev && !this.$cookies.get('tk')) {
    //   this.$cookies.set('customer_name', 'AutoCloud');
    //   this.$cookies.set('customer', 'autocloud');
    //   this.$cookies.set('openid', '');
    //   this.$cookies.set('imei', '');
    //   this.$cookies.set('tk', '');
    // }
    //
    // // 每次加载的时候从cookie中获取最新token
    // this.$store.state.customerName = this.$cookies.get('customer_name');
    // this.$store.state.customer = this.$cookies.get('customer') || this.$route.query.customer;
    // this.$store.state.nowImei = this.$cookies.get('imei');

    this.customerName = this.$cookies.get('customer_name');
    this.customer = this.$cookies.get('customer');
    this.nowImei = this.$cookies.get('imei');
    this.noticeText = this.customer === 'HuLianHT' ? 'V98P流媒体云服务已全新上线，赶快下载途云APP使用哦' : '';
    // 异常提示
    if (!this.$store.state.isDev){
      if (!this.$cookies.get('tk')) {
        this.$router.push('/error?type=tk');
      } else if (!this.$cookies.get('openid')) {
        this.$router.push('/error?type=openid');
      } else if (!this.$cookies.get('customer')) {
        this.$router.push('/error?type=customer');
      } else if (!this.$cookies.get('imei')) {
        this.$router.push('/error?type=imei');
      }
    }

    // 获取设备能力(只获取一次)
    if (this.$cookies.get('tk') && !this.$store.state.devSet) {
      if(!this.nowImei){
        this.setCarInfoByImei()
      }else{
        this.getInfoFn();
      }
    }
    jsSdk(this.$store.state.customer, ['hideMenuItems']).then(function(){

    })
  }
}
